import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import {
  Alert,
  Box,
  Divider,
  EnumSpinnerLoaderPlacement,
  SpinnerLoader,
  Typography,
} from 'shared/ui'
import { DropdownCards } from 'entities/Billing/ui/DropdownCards'
import { type UrlShortenerModalStore } from 'pages/settings/pages/urlShortener/store/urlShortenerModalStore'
import styles from './styles.module.scss'

export type IActivateCustomDomainModalContentProps = {
  store: UrlShortenerModalStore
}

export const ActivateCustomDomainModalContent = observer(
  ({ store }: IActivateCustomDomainModalContentProps) => {
    const { dropdownCardsStore, isPaymentError } = store
    // todo: will be restored in the task https://salesmsg.atlassian.net/browse/SWC-16723
    // const brandedUrlShortenerTitle = store.priceInfoStore.priceInfoUiData ? (
    //   <TitledRow
    //     title={'Branded URL Shortener'}
    //     titleProps={{ color: 'var(--content-primary-primary)', variant: 'body-md-regular' }}
    //   >
    //     <Typography ariaLabel={'TierPrice'} variant={'body-md-regular'}>
    //       {`${store.priceInfoStore.priceInfoUiData.subtotal} / ${getBillingLabel(
    //         store.priceInfoStore.priceInfoUiData.interval
    //       )}`}
    //     </Typography>
    //   </TitledRow>
    // ) : null

    const subscriptionPrice = () => {
      const interval = store.priceInfoStore.priceInfoUiData?.interval
      const paymentInfo = {
        period: '',
        periodFee: '',
        total: store.priceInfoStore.priceInfoUiData?.totalDueToday || '',
      }

      switch (interval) {
        case 'annual':
          paymentInfo.period = 'Yearly'
          paymentInfo.periodFee = '$240.00/annual'
          break

        case 'semi-annual':
          paymentInfo.period = 'Semi-Annual'
          paymentInfo.periodFee = '$120.00/6 months'
          break

        case 'quarterly':
          paymentInfo.period = 'Quarterly'
          paymentInfo.periodFee = '$60.00/3 months'
          break

        default:
          paymentInfo.period = 'Monthly'
          paymentInfo.periodFee = '$20.00/month'
      }

      return paymentInfo
    }

    const priceInfo = store.priceInfoStore.priceInfoUiData ? subscriptionPrice() : null

    useEffect(() => {
      void store.priceInfoStore.loadPriceData()
    }, [store])

    return (
      <>
        <Typography
          ariaLabel={'contactName'}
          variant={'heading-lg'}
          marginBottom={24}
          color={'var(--content-primary-primary)'}
        >
          Branded URL Shortener
        </Typography>

        {isPaymentError && (
          <Alert
            item={{
              type: 'error',
              title: 'We were unable to process your payment',
              desc: 'Please select a different card',
            }}
            marginBottom={32}
          />
        )}

        {!store.priceInfoStore.priceInfoUiData ? (
          <div style={{ minHeight: 200, position: 'relative' }}>
            <SpinnerLoader
              ariaLabel={'ActivateCustomDomainModalContent'}
              placement={EnumSpinnerLoaderPlacement.Center}
            />
          </div>
        ) : (
          // todo: will be restored in the task https://salesmsg.atlassian.net/browse/SWC-16723
          // <PriceInfo priceInfoStore={store.priceInfoStore} title={brandedUrlShortenerTitle} />

          <div className={styles.priceInfo}>
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography ariaLabel={'subscription-period'} variant={'body-md-regular'}>
                Custom Domain {priceInfo?.period} Fee (recurring)
              </Typography>
              <Typography ariaLabel={'subscription-period-fee'} variant={'body-md-regular'}>
                {priceInfo?.periodFee}
              </Typography>
            </Box>

            <Divider
              sx={{ borderColor: 'var(--black-20)', marginTop: '4px', marginBottom: '4px' }}
            />

            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography ariaLabel={'TotalDueTodayTitle'} variant={'body-lg-medium'}>
                Total due today
              </Typography>
              <Typography ariaLabel={'TotalDueTodayValue'} variant={'body-lg-medium'}>
                {priceInfo?.total}
              </Typography>
            </Box>
          </div>
        )}

        {isPaymentError && dropdownCardsStore && (
          <Box marginTop={'16px'}>
            <DropdownCards store={dropdownCardsStore} />
          </Box>
        )}
      </>
    )
  }
)
